<template>
  <div class="bg-white rounded border-0 shadow-sm">
    <div class="d-flex align-items-end p-3">
      <div class="d-flex flex-column">
        <h5 class="mb-1">Variants</h5>
        <p class="text-gray-500">These are the pre-defined variants which are based on the 4 color variants</p>
      </div>
      <ButtonGroup>
        <b-button :class="{'active' : viewMulti === 'preview'}" @click="viewMulti = 'preview'">Preview</b-button>
        <b-button :class="{'active' : viewMulti === 'code'}"  @click="viewMulti = 'code'">Code</b-button>
    </ButtonGroup>
    </div>
      
    <CodePreviewViewer :viewMode="viewMulti" :codeSample="require('./splash_message_variants.js').default">
      <template v-slot:preview>
        <b-button variant="primary" @click="openSplashMessage('primary')">Primary Splash Message</b-button>
        <b-button variant="success" @click="openSplashMessage('success')">Success Splash Message</b-button>
        <b-button variant="warning" @click="openSplashMessage('warning')">Warning Splash Message</b-button>
        <b-button variant="danger" @click="openSplashMessage('danger')">Danger Splash Message</b-button>
        <SplashMessage ref='splashMessage'/>
      </template>
    </CodePreviewViewer>
  </div>
</template>

<script>
import SplashMessage from '@/components/export/SplashMessage/SplashMessage'
import ButtonGroup from '@/components/export/ButtonGroup/ButtonGroup'
import CodePreviewViewer from '@/components/local/CodePreviewViewer'

export default {
  components: { ButtonGroup, CodePreviewViewer, SplashMessage },
  data () {
    return {
      viewMulti: 'preview',
      variants: [
        'primary',
        'success',
        'warning',
        'danger'
      ]
    }
  },
  methods: {
    openSplashMessage (variant) {
      if (variant === 'primary') {
        this.$refs.splashMessage.show({title: `Primary Box`, description: 'Description of what the info is all about.', variant: 'primary'})
      } else if (variant === 'success') {
        this.$refs.splashMessage.show({title: `Success!`, description: 'Description of what just happened.', variant: 'success'})
      } else if (variant === 'warning') {
        this.$refs.splashMessage.show({title: `Warning`, description: 'Description of what the warning is.', variant: 'warning'})
      } else {
        this.$refs.splashMessage.show({title: `Error!`, description: 'Something went wrong.', variant: 'danger'})
      }
    }
  }
}
</script>